import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { SimpleDialog, Button, SimpleUtility } from "simple-ui-components";

import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import { post, put } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { getTranslation } from "../languageProvider";
import {
  Log,
  selectNextOnEnter,
  UpdateInputChange,
  ReplaceWord,
} from "../shared/utility";
import FormHooks from "../shared/formHooks";

export const AddEditModel = forwardRef(({ UpdateSuccess }, ref) => {
  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;
  const { UpdateObject } = SimpleUtility;

  const { snackbarHandler } = useContext(AuthContext);

  const nameRef = useRef();
  const submitRef = useRef();

  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [toEdit, setToEdit] = useState({});
  const [currentBrand, setCurrentBrand] = useState("");
  const [formInputs, setFormInputs] = useState({
    name: {
      type: "input",
      label: "0124",
      value: "",
      validation: {
        required: true,
        min: 1,
        max: 30,
      },
      valid: false,
      touched: false,
      inputRef: nameRef,
      input: {
        type: "text",
        onKeyDown: (e) => selectNextOnEnter(e, submitRef),
      },
    },
    submit: {
      valid: false,
      isSubmit: false,
      inputRef: submitRef,
    },
  });

  const handleClose = () => setOpen(false);

  // trigger from props
  useImperativeHandle(ref, () => ({
    AddEditModelHandler(type, brand, model) {
      setOpen(true);
      setCurrentBrand(brand);
      setIsEdit(type === "edit");
      if (type === "edit") {
        setToEdit(model);

        setFormInputs((prev) =>
          UpdateObject(prev, {
            name: UpdateObject(prev.name, {
              value: model.name,
              valid: false,
              touched: false,
            }),
            submit: UpdateObject(prev.submit, {
              valid: false,
            }),
          })
        );
      } else {
        setToEdit({});

        setFormInputs((prev) =>
          UpdateObject(prev, {
            name: UpdateObject(prev.name, {
              value: "",
              valid: false,
              touched: false,
            }),
            submit: UpdateObject(prev.submit, {
              valid: false,
            }),
          })
        );
      }
    },
  }));

  const clickAddEditHandler = (e) => {
    if (formInputs.submit.valid) {
      e.preventDefault();
      let toSend = {
        name: nameRef.current.value,
        brandId: currentBrand.id,
      };
      if (isEdit) {
        delete toSend.brandId;
        put("models", toSend, {
          id: toEdit.id,
          brandId: currentBrand.id,
        })
          .then(() => {
            snackbarHandler(
              getTranslation("0115") &&
                ReplaceWord(
                  getTranslation("0115"),
                  "**NAME**",
                  getTranslation("0085")
                ),
              "success"
            );
            setOpen(false);
            UpdateSuccess();
          })
          .catch((status) => {
            snackbarHandler(getTranslation(`error${status}`));
            Log("Error: update models" + status);
          });
      } else {
        // create Brand
        post("models", toSend)
          .then(() => {
            snackbarHandler(
              getTranslation("0116") &&
                ReplaceWord(
                  getTranslation("0116"),
                  "**NAME**",
                  getTranslation("0085")
                ),
              "success"
            );
            setOpen(false);
            UpdateSuccess();
          })
          .catch((status) => {
            snackbarHandler(getTranslation(`error${status}`));
            Log("Error: create models" + status);
          });
      }
    }
  };

  const inputChangeHandler = (e, key) =>
    setFormInputs(UpdateInputChange(formInputs, e.target.value, key));

  return (
    <>
      {open && (
        <Dialog
          theme="default"
          size="sm"
          close={handleClose}
          open={open}
          title={
            isEdit
              ? `${getTranslation("0070")} ${
                  getTranslation("0085") && getTranslation("0085").toLowerCase()
                }`
              : `${getTranslation("0087")} ${
                  getTranslation("0085") && getTranslation("0085").toLowerCase()
                }`
          }
        >
          <DialogBody>
            <FormHooks
              formInputs={formInputs}
              inputChange={inputChangeHandler}
              onSubmit={clickAddEditHandler}
              size="md"
              layout="outline"
            />
          </DialogBody>
          <DialogFooter multiple={true}>
            <Button
              type="button"
              clicked={clickAddEditHandler}
              icon={isEdit ? <SaveOutlinedIcon /> : <AddOutlinedIcon />}
              text={isEdit ? getTranslation("0024") : getTranslation("0087")}
              className={isEdit ? "btn-primary" : "btn-secondary"}
              theme={formInputs.submit.valid ? "default" : "disabled"}
              style={{ marginLeft: "auto" }}
            />
          </DialogFooter>
        </Dialog>
      )}
    </>
  );
});
